export const MAX_FILE_SIZE = 5;
export const MAX_JOB_PHOTOS = 10;
export const imageFormats = ['.jpeg', '.jpe', '.jif', '.jfif', '.jfi', '.jpg', '.png'];
export const documentFormats = ['JPG', 'PNG', 'WebP', 'HEIC', 'PDF'];
export const MAX_DOCUMENT_FILE_SIZE = 10;
const documentMimeTypes = ['image/jpeg', 'image/png', 'image/webp', 'image/heic', 'image/heif', 'application/pdf'];

export const convertWebFormat = webFormat => '.' + webFormat.substr(webFormat.lastIndexOf('/') + 1);

export const bytesToMB = bytes => bytes / (1024*1024);

export const isValidFileSize = fileSize => bytesToMB(fileSize) < MAX_FILE_SIZE;

export const isValidFileFormat = fileFormat => imageFormats.includes(fileFormat);

export const isValidFile = file => {
    if (!isValidFileSize(file.size)) {
        return { isValid: false, error: 'ImageSizeNotice' };
    }

    if (!isValidFileFormat(convertWebFormat(file.type))) {
        return { isValid: false, error: 'ImageTypeNotice' };
    }

    return { isValid: true };
}

export const isValidDocumentFile = file => {
    if (!file) return { isValid: false, error: 'DocumentFileRequired' };
    if (bytesToMB(file.size) > MAX_DOCUMENT_FILE_SIZE) return { isValid: false, error: 'DocumentFileTooLarge' };
    const extension = file.name?.toLowerCase().split('.').pop();
    const validExtension = ['jpg', 'jpeg', 'png', 'webp', 'heic', 'heif', 'pdf'].includes(extension);
    if (!documentMimeTypes.includes(file.type) && !validExtension) return { isValid: false, error: 'UnsupportedDocumentFormat' };
    return { isValid: true };
}
